import React, { useState } from 'react';
import ComchekCreate from './ComchekCreate';
import ComchekAction from './ComchekAction';
import classes from './Comchek.module.css';

type ComchekModalProps = {
  driverId?: number;
  loadId?: number;
  rentalId?: number;
  defaultTab?: 'create' | 'status' | 'cancel';
  onSubmit?: () => void;
  onSuccess?: () => void;
};

export default function Comchek({
  driverId,
  loadId,
  rentalId,
  defaultTab = 'create',
  onSubmit,
  onSuccess
}: ComchekModalProps) {
  const [activeTab, setActiveTab] = useState<'create' | 'status' | 'cancel'>(
    defaultTab,
  );

  return (
    <div className={classes.container}>
      <div className={classes.tabContainer}>
        <button
          type="button"
          className={`${classes.tab} ${
            activeTab === 'create' ? classes.active : ''
          }`}
          onClick={() => setActiveTab('create')}
        >
          Create
        </button>
        <button
          type="button"
          className={`${classes.tab} ${
            activeTab === 'status' ? classes.active : ''
          }`}
          onClick={() => setActiveTab('status')}
        >
          Check Status
        </button>
        <button
          type="button"
          className={`${classes.tab} ${
            activeTab === 'cancel' ? classes.active : ''
          }`}
          onClick={() => setActiveTab('cancel')}
        >
          Cancel
        </button>
      </div>
      <div className={classes.tabContent}>
        {activeTab === 'create' && (
          <ComchekCreate
            driverId={driverId}
            loadId={loadId}
            rentalId={rentalId}
            onSubmit={onSubmit}
            onSuccess={onSuccess}
          />
        )}
        {activeTab === 'status' && (
          <ComchekAction
            action="status"
            endpoint="/Comchek/GetComchekStatus"
            buttonText="Check Status"
            buttonVariant="good"
            onSuccess={onSuccess}
          />
        )}
        {activeTab === 'cancel' && (
          <ComchekAction
            action="cancel"
            endpoint="/Comchek/CancelComchek"
            buttonText="Cancel Comchek"
            buttonVariant="bad"
            onSuccess={onSuccess}
          />
        )}
      </div>
    </div>
  );
}
